import Drawer from '../../../../../components/Drawer';
import Breadcrumb from '../../../../../components/Breadcrumb';
import Table from '../../../../../components/Table';
import styled from 'styled-components';
import { useGetFundsByPeriodId } from '../../../../../services/funds.service';
import Button from '../../../../../components/Button';
import OutlinedNavigateIcon from '../../../../../assets/icons/navigate-outlined.svg?react';
import { useNavigate } from 'react-router-dom';
import { checkIsLockedAutomation } from '../../../../../utils/lockAutomation';
import { Flex } from '@mantine/core';
import { REPORT_NAMINGS } from '../../../../../consts/reportTypes';

export const ReadonlyAIFDrawer = ({
  isOpen,
  onClose,
  periodId,
  selectedPeriod,
  currentUser,
  isLatestPeriod,
  reportType
}) => {
  const navigate = useNavigate();

  const { data, isLoading } = useGetFundsByPeriodId({
    periodId: periodId,
    queryParams: {
      enabled: !!periodId && !!isOpen
    }
  });

  const isLockedPeriod = checkIsLockedAutomation(selectedPeriod, currentUser);

  const links = [
    {
      name: `Added ${REPORT_NAMINGS.FUND?.[reportType]}s`,
      style: {
        fontSize: '16px'
      }
    }
  ];

  const columns = [
    {
      title: (
        <Tr>
          <span>Added {REPORT_NAMINGS.FUND?.[reportType]}s</span>
          <span>
            {data?.length || 0} {REPORT_NAMINGS.FUND?.[reportType]}s
          </span>
        </Tr>
      ),
      key: 'name',
      tdProps: {
        style: {
          height: 64
        }
      }
    }
  ];

  const onClickEdit = () => {
    // AddAIFs handles both scratch and automation periods now (the page
    // branches internally on `template_type === 'sratch'`). No more
    // separate routing for scratch.
    navigate(`/project/quaters/${selectedPeriod.workflow_id}/${selectedPeriod.id}/add-aifs`);
  };

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      title={
        <Flex alignItems="center" gap={8}>
          <Breadcrumb links={links} />
        </Flex>
      }
      style={{
        maxWidth: 410,
        minWidth: 410
      }}
    >
      <Table data={data} columns={columns} hasIndex={false} isLoading={isLoading} />
      {!isLockedPeriod && isLatestPeriod && (
        <ActionBox>
          <Button
            size="sm"
            variant="outlined"
            rightIcon={<OutlinedNavigateIcon />}
            onClick={onClickEdit}
          >
            Open Edit {REPORT_NAMINGS.FUND?.[reportType]}’s Page
          </Button>
        </ActionBox>
      )}
    </Drawer>
  );
};

const Tr = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const ActionBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
`;
